import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../services/data.service';
import { Subscription } from 'rxjs';
import { Unidad } from 'src/app/models/unidad';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ServiceComponents } from '../../../components/service/serviceComponents.service';
import { Rutas } from 'src/app/models/rutas';

@Component({
    selector: 'app-menu-mobile',
    templateUrl: './menu-mobile.component.html',
    styleUrls: ['./menu-mobile.component.scss']
})
export class MenuMobileComponent implements OnInit {
    public expandir: boolean = false;
    activeLang = 'es';
    subscription: Subscription;
    idIdioma = '';

    ttHotel: string;
    tituloHoteles: string;
    tituloByEnjoyCasino: string;
    tituloHotelByEnjoy: string;

    unidades: Unidad[];
    url: string;
    selectedItem: any = {};
    unidadSelected: Unidad;
    rutaEnjoyClub: Rutas;
    rutaEnjoySerie: Rutas;
    rutaEnjoyWin: Rutas;

    constructor(
        private translate: TranslateService,
        private dataService: DataService,
        private serviceComponent: ServiceComponents,
        private router: Router,
        @Inject(PLATFORM_ID) public platformId: Object,

    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.translate.setDefaultLang(this.activeLang);
        }

    }

    ngOnInit() {
        this.getLink();

    }

    async getLink() {
        const RUTAS = await this.serviceComponent.getLinks()
            .then(resRuta => {
                if (resRuta['codigo'] === 1) {
                    const RUTACLUB = resRuta['data'];
                    this.rutaEnjoyClub = new Rutas(RUTACLUB[1]);
                    this.rutaEnjoySerie = new Rutas(RUTACLUB[2]);
                    this.rutaEnjoyWin = new Rutas(RUTACLUB[6]);
                }
            });

        this.dataService.currentUrl.subscribe(url => this.url = url);
        this.subscription = this.dataService.$idioma.subscribe(value => {
            this.idIdioma = value;
            this.activeLang = value;
            switch (this.idIdioma) {
                case 'es': {
                    this.traducir('HOTEL', 'HOTELES', 'BY ENJOY Y CASINO', 'HOTEL BY ENJOY');
                    break;
                }
                case 'en': {
                    this.traducir('HOTEL', 'HOTELS', 'BY ENJOY AND CASINO', 'HOTEL BY ENJOY');
                    break;
                }
                case 'port': {
                    this.traducir('HOTEL', 'HOTÉIS', 'BY ENJOY E CASINO', 'HOTEL BY ENJOY');
                    break;
                }
                default:
                    this.traducir('HOTEL', 'HOTELES', 'BY ENJOY Y CASINO', 'HOTEL BY ENJOY');
                    break;
            }
            this.dataService.currentUnidades.subscribe(unidades => {
                this.unidades = unidades;
                this.selectedItem = this.unidades.find(unidad => unidad.esHotel);
            });
        });
        this.cerrarCollapse();


    }
    traducir(tt: string, titulo1: string, titulo2: string, titulo3: string) {
        this.ttHotel = tt;
        this.tituloHoteles = titulo1;
        this.tituloByEnjoyCasino = titulo2;
        this.tituloHotelByEnjoy = titulo3;
    }

    closemenu(event) {

        const el: HTMLElement = event.target.parentNode as HTMLElement;
        var myTarget = el.getAttribute('data-target');

        console.log(myTarget);

        //el.classList.add('show');
        /*
            if (this.expandir == true)
              this.expandir = false;
            return true;
        */
    }

    setLanguage(lang) {
        this.activeLang = lang;
        if (isPlatformBrowser(this.platformId)) {
            this.translate.use(lang);
        }
        this.dataService.setIdioma(lang);
    }

    showUnidad(item) {
        //force Panel close
        let AccordionAll = document.getElementById('nav-content3');
        AccordionAll.classList.remove('show');
        this.selectedItem = item;
        this.goUnidad(item);
    }

    goUnidad(item) {
        this.dataService.changeUnidadSelected(item);
        this.router.navigate([`/${item.nombre.replace(/[' ']+/g, '-').toLowerCase()}`]);
    }

    isSelectedItem(item) {
        return isNullOrUndefined(this.selectedItem) ? false : this.selectedItem.idUnidad === item.idUnidad;
    }

    cerrarCollapse() {
        let MenuCollapse: HTMLElement = document.getElementById('nav-content') as HTMLElement;
        let MenuCollapse3: HTMLElement = document.getElementById('nav-content3') as HTMLElement;
        if (MenuCollapse.classList.contains('show')) {
            MenuCollapse.classList.remove('show');

        }
        if (MenuCollapse3.classList.contains('show')) {
            MenuCollapse3.classList.remove('show');

        }
    }
}

